import dataService from 'services/dataService';
import {
  apiPatientReadings,
  API_READINGS_ACTIONS,
} from 'services/dataService/resources';

const ITEMS_PER_PAGE = 100;

const INITIAL_STATE = {
  reviewed: false,
  page: 1,
  itemsPerPage: ITEMS_PER_PAGE,
  sort: {
    time: false,
  },
  data: [],
  totalPages: 0,
  totalCount: 0,
};

const activity = {
  state: INITIAL_STATE,
  reducers: {
    reset: () => INITIAL_STATE,
    setReviewed: (state, payload) => ({
      ...state,
      reviewed: payload,
    }),
    setPage: (state, payload) => ({
      ...state,
      page: payload < 1 ? 1 : payload,
    }),
    setTotalCountAndTotalPages: (state, payload) => ({
      ...state,
      totalCount: payload.totalCount,
      totalPages: payload.totalPages,
    }),
    setActivities: (state, payload) => ({
      ...state,
      data: payload,
    }),
    toggleTimeSort: (state) => ({
      ...state,
      sort: {
        ...state.sort,
        time: !state.sort.time,
      },
    }),
  },
  effects: (dispatch) => ({
    async getActivities(
      { patientGuid, clinicGuid, reviewed, items = ITEMS_PER_PAGE, userType },
      state,
    ) {
      const { page, sort, reviewed: stateReviewed } = state.activity;
      const { dates } = state.patient;
      const [startTime, endTime] = dates;
      const { data } = await dataService.getList(
        apiPatientReadings(
          patientGuid,
          clinicGuid,
          reviewed ?? stateReviewed,
          items,
          page,
          startTime,
          endTime,
          userType,
          sort.time,
        ),
      );
      if (data) {
        dispatch.activity.setActivities(data?.data || []);
        const totalCount = data?.count || 0;
        const totalPages = Math.ceil(totalCount / ITEMS_PER_PAGE);
        dispatch.activity.setTotalCountAndTotalPages({
          totalCount,
          totalPages,
        });
      } else {
        dispatch.activity.setActivities([]);
        dispatch.activity.setTotalCountAndTotalPages({
          totalCount: 0,
          totalPages: 0,
        });
      }
    },
    async submitComment(postData, state) {
      const { error, data } = await dataService.createOne(
        API_READINGS_ACTIONS,
        postData,
      );
      if (!error) {
        const updatedData = state.activity.data.map((item) =>
          item.id === data.readingId && item.deviceId === data.deviceId
            ? { ...item, comments: [data, ...item.comments] }
            : item,
        );
        dispatch.activity.setActivities(updatedData);
      }
      return { error, data };
    },
    async actionReview(postData, state) {
      const { error, data } = await dataService.createOne(
        API_READINGS_ACTIONS,
        postData,
      );
      if (!error) {
        const updatedData = state.activity.data.map((item) => {
          if (item.id !== data.readingId || item.deviceId !== data.deviceId)
            return item;
          return {
            ...item,
            disabled: true,
          };
        });
        dispatch.activity.setActivities(updatedData);
      }
      return { error, data };
    },
    async changeReviewed({ patientGuid, clinicGuid }, state) {
      const { reviewed } = state.activity;

      dispatch.activity.reset();
      dispatch.activity.setReviewed(!reviewed);

      dispatch.activity.getActivities({
        patientGuid,
        reviewed: !reviewed,
        clinicGuid,
      });
    },
    async setActivitiesPage(
      { patientGuid, clinicGuid, pageOffset, userType, goToPage },
      state,
    ) {
      const { activity: activityState } = state;
      const { page, reviewed, totalPages } = activityState;
      const newPage = goToPage || page + pageOffset;

      dispatch.activity.setPage(newPage <= totalPages ? newPage : totalPages);

      return dispatch.activity.getActivities({
        patientGuid,
        clinicGuid,
        page: newPage,
        reviewed,
        userType,
      });
    },
    async toggleActivitiesTimeSort(
      { patientGuid, clinicGuid, userType },
      state,
    ) {
      const { reviewed } = state.activity;

      dispatch.activity.toggleTimeSort();
      return dispatch.activity.getActivities({
        patientGuid,
        clinicGuid,
        reviewed,
        userType,
      });
    },
  }),
};

export default activity;
